export default __webpack_public_path__ + "699853aecc6e10c8ff2efd2d3c40cd08.png";